<template>
  <div>
    <TheYaTeCommonHeaderNolink />
    <main class="bg-co-gray-100">
      <slot />
    </main>
    <TheYaTeCommonFooterSimple />
  </div>
</template>

<script setup lang="ts">
import TheYaTeCommonHeaderNolink from '~/components/YaTe/YaTeCommon/Header/TheYaTeCommonHeaderNolink.vue'
import TheYaTeCommonFooterSimple from '~/components/YaTe/YaTeCommon/Footer/TheYaTeCommonFooterSimple.vue'

useHead({
  htmlAttrs: {
    class: '!bg-black',
    'data-theme': 'lineyahoo',
  },
  bodyAttrs: {
    class: 'bg-co-gray-200',
  },
  link: [
    {
      hid: "favicon",
      rel: 'icon',
      type: 'image/x-icon',
      href: '/favicon-yate.ico',
    },
  ],
})
</script>
